const Empty = () => {
  return <></>;
};

export default Empty;
